// Moves the row at `from` to `to` and renumbers every row by its new position.
//
// Renumbering, rather than swapping the two rows' `order` values, is what keeps the arrows
// working on a profile whose rows share an `order` value. It also repairs such a profile the first
// time any row in it is moved.
export const moveRow = (rows, from, to) => {
  const reordered = [...rows];
  const [moved] = reordered.splice(from, 1);
  reordered.splice(to, 0, moved);
  return reordered.map((row, order) => ({ ...row, order }));
};

// The `order` that sorts a new row after every existing one. The last row's `order` + 1 is not
// enough: when orders are tied or out of sequence the last row does not hold the highest value.
export const nextOrder = (rows) => rows.reduce((highest, row) => Math.max(highest, row.order ?? -1), -1) + 1;
